module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074a5_banner_800x600.bf79b9ed.png";